/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
import { mapActions, mapState, mapMutations } from 'vuex';
import webSocket from '@/common/webSocket';

const OnlineUsersMixin = {
  data() {
    return {
      stompClientForOnlineUsers: null,
      connectionTimerOnlineUsers: null,
      onlineSubscription: null,
    };
  },
  beforeDestroy() {
    if (this.onlineSubscription) {
      this.onlineSubscription.unsubscribe();
    }
  },
  methods: {
    ...mapActions('profile', [
      'subscribeUserForOnlineChannelAndThenOpenTheChannel',
    ]),
    ...mapMutations('users', [
      'setOnlineUsers',
    ]),
    onlineUsersMixin() {
      this.stompClientForOnlineUsers = webSocket.getOnlineChannelStompClient();
      if (this.stompClientForOnlineUsers === null) {
        this.stompClientForOnlineUsers = webSocket.createNewStompClient('/onlineChannel');
      }

      const stompSuccess = (frame) => {
        clearTimeout(this.connectionTimerOnlineUsers);
        // eslint-disable-next-line
        console.log(`In Home component: ${frame}`);
        // eslint-disable-next-line
        console.log(`Subscribing to channel: /topic/onlineChannel/${this.userDetails.msisdn}`);
        // eslint-disable-next-line
        this.onlineSubscription = this.stompClientForOnlineUsers.subscribe(`/topic/onlineChannel/`, (response) => {
          // eslint-disable-next-line
          console.log('[Home] Inside online channel response');
          // parse server response and return if any errors occur
          const responseBody = this.parseServerResponse(response.body);
          if (responseBody === null) {
            return;
          }
          const responseData = responseBody.data;
          // eslint-disable-next-line
          console.log('responseData:', responseData);
          this.setOnlineUsers(responseData.activeUserDTOS);
        }, (errorResponse) => { // error callback
          console.log(errorResponse);
        });
      };
      const stompFailure = (error) => {
        // eslint-disable-next-line
        console.log(error);
        clearTimeout(this.connectionTimerOnlineUsers);
        this.connectionTimerOnlineUsers = setTimeout(() => {
          this.stompClientForOnlineUsers = webSocket.createNewStompClient('/onlineChannel');
          connect();
        }, 3000);
      };

      const connect = (() => {
        if (!this.stompClientForOnlineUsers.connected) {
          this.stompClientForOnlineUsers.connect({ Authorization: this.jwtInVuex }, stompSuccess, stompFailure);
        } else {
          stompSuccess();
        }
      });
      connect();
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
  },
};

export default OnlineUsersMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/onlineusers/onlineusers.js